angular.module(NgAppName).service('windowEvents', ['$window', 'PubSub', function($window, PubSub) {
	var w = angular.element($window);

	w.bind('scroll', function() {
		PubSub.publish('scrollEvent');
	});

	w.bind('resize', function() {
		PubSub.publish('resizeEvent');
	});
}]);
